import {
  PIPEFITTER_SET_CONFIGURATION_LOADING,
  PIPEFITTER_SET_CONFIGURATION_LIST,
} from './types';

const initialState = {
  isConfigurationLoading: false,
  configurationList: [],
};

export default function pipefitterConfigurationReducer(state = initialState, action) {
  switch (action.type) {
    case PIPEFITTER_SET_CONFIGURATION_LOADING:
      return { ...state, isConfigurationLoading: action.payload };
    case PIPEFITTER_SET_CONFIGURATION_LIST:
      return { ...state, configurationList: action.payload };
    default:
      return state;
  }
}
